import React from 'react';
import { Box, Paper, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import RawStockHistoryTable from '../../components/transaction/RawStockHistoryTable';

const RawStockHistoryPage = () => {
  return (
    <>
      <Box sx={{ mb: 2 }}>
        <Button
          component={Link}
          to="/activity-log"
          variant="contained"
          color="primary"
        >
          View Activity Log
        </Button>
      </Box>
      <Box sx={{ p: 2 }}>
        <Paper elevation={3} sx={{ p: 3 }}>
          <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 3 }}>
            Raw Stock Addition History
          </Typography>
          <Typography variant="body2" sx={{ mb: 3, color: 'text.secondary' }}>
            This page displays the complete history of all raw stock additions, updates, and modifications. 
            You can see who added what stock, when it was added, and track all changes over time.
          </Typography>
          <RawStockHistoryTable />
        </Paper>
      </Box>
    </>
  );
};

export default RawStockHistoryPage; 